import { useQueryParams } from "@certn/api";
import { Stack } from "@certn/cascadia";
import { Picker } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Search } from "@certn/cascadia-react";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
interface FilterOption {
  id: string;
  name: string;
}
interface FilterProps {
  label: string;
  paramKey: string;
  items: FilterOption[];
  testID: string;
}

const getSortDirectionOptions = (t: TFunction): FilterOption[] => [
  { id: "ascending", name: t("Ascending") },
  { id: "descending", name: t("Descending") },
];

const PARAM_KEYS = {
  SORT: "sort",
  CATEGORY: "category",
  SEARCH: "search",
} as const;

function Filter({ label, paramKey, items, testID }: FilterProps) {
  const { getParamsAsArray, setParam } = useQueryParams();

  return (
    <Picker
      selectionMode="single"
      showActionBar
      selectedKeys={getParamsAsArray(paramKey)}
      onSelectionChange={(keys) =>
        setParam(paramKey, Array.from(keys).map(String), true)
      }
      label={label}
      items={items}
      testID={testID}
    />
  );
}

export function Filters({ categories }: { categories: string[] }) {
  const { setParam, flatParams } = useQueryParams();
  const { t } = useTranslation();

  const categoryOptions: FilterOption[] = categories.map((category) => ({
    id: category,
    name: category,
  }));

  return (
    <Stack orientation="horizontal" justify="space-between">
      <Stack orientation="horizontal" className={styles.filtersContainer}>
        <Filter
          label={t("Direction")}
          paramKey={PARAM_KEYS.SORT}
          items={getSortDirectionOptions(t)}
          testID="sort-direction-filter"
        />
        <Filter
          label={t("Category")}
          paramKey={PARAM_KEYS.CATEGORY}
          items={categoryOptions}
          testID="category-filter"
        />
      </Stack>
      <Search
        debounce={0}
        value={flatParams[PARAM_KEYS.SEARCH] ?? ""}
        placeholder={t("Search checks...")}
        aria-label={t("Search checks...")}
        testID="search-filter"
        onChange={(search) => setParam(PARAM_KEYS.SEARCH, search, true)}
      />
    </Stack>
  );
}

const styles = {
  filtersContainer: css({
    columnGap: "var(--space-2) !important",
  }),
};
